import { useConnect } from '@lore/query-connect';
import { project_networkId } from '@/utils/query-helpers';

export default function useProjectInvitationsCreated(network, timestamp) {
  return useConnect('question.find', {
    where: {
      eager: {
        $where: {
          ...project_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          },
          request: { $not: 'Outreach' }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
